const GOVUK_DOMAIN = 'https://www.gov.uk';

// Site
export const GOVUK_URL = `${GOVUK_DOMAIN}/`;
export const LANDING_URL = '/';

// External URLs
export const ABILITY_NET_MCMW_URL = 'https://mcmw.abilitynet.org.uk';
export const C384_VESSEL_FORM = `${GOVUK_DOMAIN}/government/publications/import-and-export-private-vessel-application-for-release-on-payment-of-customs-duty-and-vat-c384-vessels`;
export const CHK_IMMIGRATION_STATUS_LINK = `${GOVUK_DOMAIN}/check-immigration-status`;
export const CROWN_COPYRIGHT_URL =
  'https://www.nationalarchives.gov.uk/information-management/re-using-public-sector-information/uk-government-licensing-framework/crown-copyright/';
export const DATA_PROTECTION_ACT_URL = `${GOVUK_DOMAIN}/data-protection`;
export const EQUALITY_ADVISORY_SERVICE_URL = 'https://www.equalityadvisoryservice.com';
export const EQUALITY_NI_URL = 'https://www.equalityni.org/Home';
export const ETA_GUIDANCE_ON_GOVUK_URL = `${GOVUK_DOMAIN}/guidance/apply-for-an-electronic-travel-authorisation-eta`;
export const EXAMINING_IDENTITY_DOCS_URL = `${GOVUK_DOMAIN}/government/publications/recognising-fraudulent-identity-documents`;
export const GENERAL_DATA_PROTECTION_URL = 'https://gdpr-info.eu/';
export const GUIDANCE_EXAMINING_IDENTITY_DOC =
  'https://assets.publishing.service.gov.uk/government/uploads/system/uploads/attachment_data/file/1134497/Guidance_on_examining_identity_documents.pdf';
export const IMMIGRATION_ACT_URL = 'https://www.legislation.gov.uk/ukpga/1971/77/contents';
export const GUIDANCE_EXAMINING_IDENTITY_LINK =
  'https://www.gov.uk/government/publications/recognising-fraudulent-identity-documents';
export const PC_CUSTOMS_RULES = `${GOVUK_DOMAIN}/government/collections/custom-rules-for-sailing-your-pleasure-craft-to-from-and-within-uk-waters`;
export const PRIVACY_INFO_NOTICE_URL = `${GOVUK_DOMAIN}/government/publications/personal-information-use-in-borders-immigration-and-citizenship`;
export const UK_VISA_REQUIREMENT_LINK = `${GOVUK_DOMAIN}/government/publications/uk-visa-requirements-list-for-carriers/uk-visa-requirements-for-international-carriers`;
export const VISA_CHECK_URL = `${GOVUK_DOMAIN}/check-uk-visa/y`;
export const VISA_GUIDANCE_URL = `${GOVUK_DOMAIN}/guidance/immigration-rules/immigration-rules-appendix-visitor-visa-national-list`;
export const VISA_IMMIGRATION_URL = `${GOVUK_DOMAIN}/browse/visas-immigration`;
export const CHECK_IMMIGRATION_STATUS_URL = `${GOVUK_DOMAIN}/check-immigration-status`;
export const CHECK_ETA_URL = `${GOVUK_DOMAIN}/check-eta`;
export const WCAG_22_URL = 'https://www.w3.org/TR/WCAG22/';

// Account
export const ACCOUNT_PAGE_URL = '/account';
export const EDIT_ACCOUNT_URL = '/account/edit';
export const DELETE_ACCOUNT_URL = '/account/delete-account';
export const ACCOUNT_DELETED_URL = '/account/deleted';
export const INTERSTITIAL_URL = '/information';

// Onboarding
export const ONBOARDING_PEOPLE_URL = '/onboarding/people';
export const ONBOARDING_SKIPPER_URL = '/onboarding/skipper';

// One Login
export const SIGN_IN_URL = '/sign-in';
export const CHECK_FORM_URL = '/create-account-check';
export const NAME_FORM_URL = '/create-account-your-name';
export const ONE_LOGIN_REDIRECT_URL = '/login-redirect';
export const PHONE_NUMBER_URL = '/create-account-phone-number';

// People
export const PEOPLE_PAGE_URL = '/people';
export const PERSON_ADD_URL = '/people/save-person';
export const PERSON_EDIT_URL = '/people/edit-person';

// Pleasure Crafts
export const PLEASURE_CRAFT_ADD_URL = '/pleasure-crafts/save-pleasure-craft';
export const PLEASURE_CRAFT_ADD_PAGE1_URL = '/pleasure-crafts/save-pleasure-craft/page-1';
export const PLEASURE_CRAFT_EDIT_URL = '/pleasure-crafts/edit-pleasure-craft';
export const PLEASURE_CRAFT_PAGE_URL = '/pleasure-crafts';

// Regulatory
export const ACCESSIBILITY_STATEMENT_URL = '/accessibility-statement';
export const HELP_FOOTER_URL = '/help';
/**
 * This URL is linked directly from user emails. It must not be changed without:
 * 1. Implementing a permanent redirect to the new location, and
 * 2. Updating documentation to reflect the change.
 */
export const HELP_NAV_URL = '/page/help';
export const PRIVACY_AND_COOKIE_URL = '/privacy-and-cookie-policy';
export const UPT_HELP_URL = '/permission-to-travel-help';

// Voyage
export const DASHBOARD_URL = '/voyage-plans'; // Voyage plans (dashboard)
export const MANAGE_VOYAGE_PLANS = '/manage-voyage-plans'; // Manage your voyage plans

// Create a new voyage plan journey
export const CREATE_VOYAGE_URL = '/voyage-plans/start'; // 01 Telling us about your voyage plan
export const VOYAGE_ARRIVAL_OR_DEPARTURE_UK_URL = '/save-voyage/arrival-or-departure'; // 02 What type of voyage are you reporting
export const VOYAGE_DEPARTURE_URL = '/save-voyage/departure'; // 03 Departure details
export const VOYAGE_ARRIVAL_URL = '/save-voyage/arrival'; // 04 Arrival details
export const VOYAGE_SELECT_PLEASURE_CRAFT_URL = '/save-voyage/pleasure-craft'; // 05 Which pleasure craft will you sail in?
export const VOYAGE_SELECT_PEOPLE_URL = '/save-voyage/select-people'; // 06 Who will be on board?
export const VOYAGE_PEOPLE_MANIFEST_URL = '/save-voyage/people-manifest'; // 07 X people added onboard
export const VOYAGE_EMPLOYEE_CHECK_URL = '/save-voyage/are-there-employees'; // 08 Is anyone onboard employed to provide services during this voyage?
export const VOYAGE_EMPLOYEE_SELECT_URL = '/save-voyage/select-employees'; // 09 Who is employed to provide services for this voyage?
export const VOYAGE_SKIPPER_SELECT_URL = '/save-voyage/skipper-select'; // 10 Who is the skipper for this voyage?
export const VOYAGE_SKIPPER_DETAILS_URL = '/save-voyage/skipper'; // (11 Add details of the skipper for this voyage)
export const VOYAGE_SKIPPER_DETAILS_URL_PAGE_1 = '/save-voyage/skipper/page-1'; // 11-A Add details of the skipper for this voyage
export const VOYAGE_SKIPPER_DETAILS_URL_PAGE_2 = '/save-voyage/skipper/page-2'; // 11-B Travel document details
export const VOYAGE_SKIPPER_DETAILS_URL_PAGE_3 = '/save-voyage/skipper/page-3'; // 11-C Enter the contact details for <Skipper Name>
export const VOYAGE_CUSTOMS_URL = '/voyage-plans/customs'; // 12 Information for customs
export const VOYAGE_VAT_DUE_URL = '/save-voyage/vat-due'; // 13 UK VAT for Pleasure Craft
export const VOYAGE_VAT_NO_DUE_URL = '/save-voyage/vat-no-due'; // 14 Tell us why no VAT is due on this vessel?
export const VOYAGE_TASK_LIST_URL = '/save-voyage/task-list'; // 15 Draft voyage plan (task list)
export const VOYAGE_UPT_RESULTS = '/save-voyage/permission-to-travel'; // 16 Digital permission to travel checks
export const VOYAGE_UPT_0T_RESULTS_URL = '/save-voyage/0T-results'; // 16B X Digital permission to travel check(s) timed out (0T results)
export const VOYAGE_CHECK_ANSWERS_URL = '/save-voyage/check-answers'; // 17 Check your answers before submitting your voyage plan)
export const VOYAGE_SUBMITTED_URL = '/save-voyage/voyage-submitted'; // 18 Voyage plan submitted

// Miscellaneous
export const ERROR_MESSAGE_URL = '/message-voyage';
export const MESSAGE_URL = '/message';
export const NETWORK_ERROR_MESSAGE_URL = '/message-network-error';
export const PAGE_NOT_FOUND_URL = '/page-not-found';
export const RESEND_CHECK_IN = 'resend-check-in';
export const STATUS_COUNT_PART = 'status_count=True';
export const VOYAGE_URL_ID_PART = 'voyageId';

// Top level pages - we use this to know to clear form session data
export const TOP_LEVEL_PAGES = [
  ACCESSIBILITY_STATEMENT_URL,
  ACCOUNT_PAGE_URL,
  DASHBOARD_URL,
  HELP_FOOTER_URL,
  HELP_NAV_URL,
  PEOPLE_PAGE_URL,
  PLEASURE_CRAFT_PAGE_URL,
  PRIVACY_AND_COOKIE_URL,
];

// Pages without back links
export const NO_BACK_LINKS = [
  ...TOP_LEVEL_PAGES,
  ACCOUNT_DELETED_URL,
  ERROR_MESSAGE_URL,
  INTERSTITIAL_URL,
  LANDING_URL,
  MESSAGE_URL,
  NETWORK_ERROR_MESSAGE_URL,
  PAGE_NOT_FOUND_URL,
  UPT_HELP_URL,
  VOYAGE_SKIPPER_DETAILS_URL_PAGE_3,
  VOYAGE_UPT_RESULTS,
  VOYAGE_UPT_0T_RESULTS_URL,
];

// Feature visibility control
export const NO_HELP_DETAILS = [HELP_NAV_URL, HELP_FOOTER_URL];

export const FOOTER_LINKS = {
  PRIVACY_AND_COOKIE_POLICY: { url: PRIVACY_AND_COOKIE_URL, text: 'Privacy and Cookie Policy' },
  ACCESSIBILITY: { url: ACCESSIBILITY_STATEMENT_URL, text: 'Accessibility Statement' },
  HELP: { url: HELP_FOOTER_URL, text: 'Help' },
};
